import { useIdleTimer } from "react-idle-timer";
import { useAppDispatch, useAppSelector } from "./redux";
import { setAuthState } from "../redux/Auth/auth.slice";
import { IlocalStorageProvider } from "../hexagon/adapters/driven/providers/localStorageProvider";
import { mutate } from "swr";
import { Location } from "react-router-dom";
import { useAppNavigate } from "./router";
import { routes } from "../router/mobile/routes";
interface IUseScreenTimeout {
  localStorageProvider: IlocalStorageProvider;
  location: Location;
  refreshSummary: () => Promise<void>;
  isPIN: () => boolean;
}

export const useScreenTimeout = ({
  localStorageProvider,
  location,
  refreshSummary,
  isPIN,
}: IUseScreenTimeout) => {
  const dispatch = useAppDispatch();
  const navigate = useAppNavigate();

  const { authState } = useAppSelector((state) => ({ authState: state.auth }));
  useIdleTimer({
    crossTab: true,
    leaderElection: true,
    timeout: 5 * 60000,
    syncTimers: 200,
    onIdle: () => {
      if (isPIN()) {
        refreshSummary();
        mutate(() => true, undefined, { revalidate: false });
        localStorageProvider.set("idle", "true");

        if (!location.pathname.includes("/summary")) {
          localStorageProvider.set(
            "prevUrl",
            location.pathname + location.search
          );
        }

        const isOnChime = location.pathname.includes("/chime/");
        if (!isOnChime) {
          if (isPIN()) {
            dispatch(setAuthState({ ...authState, isPinAuthorized: false }));
          } else {
            navigate(routes.SummaryScreen.path, { replace: true });
          }
        }
      }
    },
  });
};
